import axios from "axios";
import {
  TenantCreateRequest,
  TenantEditForm,
  TenantEditRequest,
  TenantNameRequest,
  TenantSearchRequest,
} from "./TenantForm";
import { AxiosResponse } from "axios";
import { ApplicationApi, ApplicationProtectedRouting } from "../../../Routing";
import { Utility } from "../../../utils/Utility";

/**
 * テナント情報管理 API
 */
export class TenantService {

  // テナント一覧取得API
  findByConditions = async (
    param: TenantSearchRequest
  ): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(
        ApplicationProtectedRouting.tenant.apiUrl(),
        param
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // テナント情報詳細取得API
  findByTenantId = async (id: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.get(
        ApplicationProtectedRouting.tenantDetail.apiUrl(id)
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // テナントの名前一覧取得API
  findTenantNameList = async (
    param: TenantNameRequest
  ): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(
        ApplicationApi.tenantName.apiUrl(),
        param
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // テナント情報情報新規作成確認API
  createConfirm = async (param: TenantEditForm): Promise<AxiosResponse> => {
    try {
      const defaultCreateDate = new Date(0);
      let request = new TenantCreateRequest();
      if (param.startView !== null) {
        let contractStart = Utility.registDateFormat(
          param.startView.toLocaleString()
        );
        param.contractStart = contractStart || "";
      }
      if (param.endView !== null) {
        let contractEnd = Utility.registDateFormat(
          param.endView.toLocaleString()
        );
        param.contractEnd = contractEnd || "";
      }
      param.createUser = "PreUser";
      param.createDate = Utility.registDateFormat(
        defaultCreateDate.toLocaleString()!
      ) || "";
      param.updateUser = "PreUser";
      param.updateDate = Utility.registDateFormat(
        defaultCreateDate.toLocaleString()!
      ) || "";
      request.createdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.tenantCreateConfirm.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // テナント情報情報新規作成API
  create = async (param: TenantEditForm): Promise<AxiosResponse> => {
    try {
      const defaultCreateDate = new Date(0);
      let request = new TenantCreateRequest();
      if (param.startView !== null) {
        let contractStart = Utility.registDateFormat(
          param.startView.toLocaleString()
        );
        param.contractStart = contractStart;
      }
      if (param.endView !== null) {
        let contractEnd = Utility.registDateFormat(
          param.endView.toLocaleString()
        );
        param.contractEnd = contractEnd;
      }
      param.createUser = "PreUser";
      param.createDate = Utility.registDateFormat(
        defaultCreateDate.toLocaleString()!
      );
      param.updateUser = "PreUser";
      param.updateDate = Utility.registDateFormat(
        defaultCreateDate.toLocaleString()!
      );
      request.createdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.tenantCreateExecute.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // テナント情報情報編集取得API
  findByEditId = async (id: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.get(
        ApplicationProtectedRouting.tenantEdit.apiUrl(id)
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // テナント情報情報編集確認API
  updateConfirm = async (param: TenantEditForm): Promise<AxiosResponse> => {
    try {
      let request = new TenantEditRequest();

      if (param.startView !== null) {
        let contractStart = Utility.registDateFormat(
          param.startView.toLocaleString()
        );
        param.contractStart = contractStart || "";
      }
      if (param.endView !== null) {
        let contractEnd = Utility.registDateFormat(
          param.endView.toLocaleString()
        );
        param.contractEnd = contractEnd || "";
      }
      request.editdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.tenantEditConfirm.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // テナント情報情報編集API
  update = async (param: TenantEditForm): Promise<AxiosResponse> => {
    try {
      let request = new TenantEditRequest();

      if (param.startView !== null) {
        let contractStart = Utility.registDateFormat(
          param.startView.toLocaleString()
        );
        param.contractStart = contractStart || "";
      }
      if (param.endView !== null) {
        let contractEnd = Utility.registDateFormat(
          param.endView.toLocaleString()
        );
        param.contractEnd = contractEnd || "";
      }
      request.editdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.tenantEditExecute.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // テナント情報情報削除API
  delete = async (tenantId: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(ApplicationApi.tenantDeleteExecute.apiUrl(), {
        tenantId,
      });
      return res;
    } catch (err) {
      throw err;
    }
  };

  // // テナント情報インポート確認API
  // importConfirm = async (uploadFile: FormData): Promise<AxiosResponse> => {
  //   try {
  //     const res: AxiosResponse = await axios.post(
  //       "/mdm_web/mdmTenant/import/confirm",
  //       uploadFile
  //     );
  //     return res;
  //   } catch (err) {
  //     throw err;
  //   }
  // };

  // // テナント情報インポートAPI
  // import = async (param: TenantImportRequest): Promise<AxiosResponse> => {
  //   try {
  //     const res: AxiosResponse = await axios.post(
  //       "/mdm_web/mdmTenant/import",
  //       param
  //     );
  //     return res;
  //   } catch (err) {
  //     throw err;
  //   }
  // };

  // // テナント情報情報エクスポートAPI
  // export = async (param: TenantSearchRequest): Promise<AxiosResponse> => {
  //   try {
  //     const res: AxiosResponse = await axios.post(
  //       "/mdm_web/mdmTenant/export",
  //       param
  //     );
  //     return res;
  //   } catch (err) {
  //     throw err;
  //   }
  // };
}
